f<template>
  <v-layout wrap justify-center class="pa-6">
    <v-flex xs12 md12>
      <v-card class="mx-auto col-12" max-width="1300" elevation="2">
        <v-card-title>
          <v-list-item>
            <v-list-item-icon>
              <v-icon size="30" color="blue darken-4 "
                >mdi-hospital-building</v-icon
              >
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="headline"
                >Servicios y Procedimientos ss</v-list-item-title
              >
            </v-list-item-content>
            <v-row justify="end">
              <v-btn
                color="indigo"
                class="ma-2 white--text"
                large
                depressed
                @click="agregar_item()"
              >
                Agregar
                <v-icon right dark class="ml-4"
                  >mdi-map-marker-plus-outline</v-icon
                >
              </v-btn>
              <v-btn
                large
                depressed
                color="green darken-2"
                class="ma-2 white--text"
                @click="imprimir_excel"
              >
                Imprimir EXCEL
                <v-icon right dark>mdi-file-excel-box</v-icon>
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-title>
        <div class="pa-0 px-8">
          <v-card-text class="px-0 pa-0">
            <v-row class="d-flex mb-4 justify-center" no-gutters>
              <v-col class="mb-4" cols="6" sm="6">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="contenido"
              item-key="identificacion_cups"
              :single-expand="singleExpand"
              :search="search"
              class="elevation-1 mytable"
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <table>
                    <thead>
                      <tr></tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ descripcionEstado(item.estado) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </template>
              <template v-slot:item.edit="{ item }">
                <v-icon small class="mr-2" @click="editar_item(item)"
                  >edit</v-icon
                >
              </template>
            </v-data-table>
          </v-card-text>
        </div>
      </v-card>
    </v-flex>
    <v-overlay :value="loader">
      <flower-spinner :animation-duration="2500" :size="100" color="#0d47a1" />
    </v-overlay>
    <v-dialog v-model="dialogo.estado" persistent max-width="1100px">
      <v-card class="px-6" :loading="card_estado" :disabled="card_estado">
        <v-card-title>
          <span class="title col-12">{{ dialogo.titulo }}</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <v-col class="d-flex" cols="4" sm="4">
              <v-text-field
                label="Codigo"
                clearable
                outlined
                type="text"
                required
                counter="4"
                v-model="form.codigo"
                :error="errores.codigo"
                @input="errores.codigo = false"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="8" sm="8">
              <v-text-field
                label="Descripción"
                clearable
                outlined
                required
                v-model="form.descripcion"
                :error="errores.descripcion"
                @input="errores.descripcion = false"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex" cols="3" sm="3">
              <v-text-field
                label="Cod.Soat"
                clearable
                outlined
                required
                v-model="form.codsoat"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="3" sm="3">
              <v-text-field
                label="Vlr Soat"
                clearable
                outlined
                required
                v-model="form.vsoat"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="3" sm="3">
              <v-text-field
                label="Cod.Iss"
                clearable
                outlined
                required
                v-model="form.codiss"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="3" sm="3">
              <v-text-field
                label="Vlr Iss"
                clearable
                outlined
                required
                v-model="form.viss"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex" cols="3" sm="3">
              <v-text-field
                label="Edad Min (Años)"
                clearable
                outlined
                required
                v-model="form.edad"
                hide-details
              ></v-text-field>
            </v-col>

            <v-col class="d-flex" cols="12" sm="3">
              <v-select
                :items="[
                  { text: 'Femenino', value: 1 },
                  { text: 'Masculino', value: 2 },
                  { text: 'Todos', value: 3 },
                ]"
                label="Genero"
                outlined
                clearable
                hide-details
                v-model="form.genero"
                item-text="text"
                item-value="value"
              ></v-select>
            </v-col>

            <v-col class="d-flex" cols="6" sm="6">
              <v-autocomplete
                label="Cuenta Ventas"
                v-model="form.ctavta"
                :items="cuentas"
                :item-text="format_cuentas"
                item-value="cod_puc"
                return-object
                outlined
                hide-details
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="d-flex" cols="8" sm="4">
              <v-select
                :items="clasifserv"
                label="Clasificación Rips"
                outlined
                clearable
                return-object
                hide-details
                v-model="form.clasifserv"
                required
              ></v-select>
            </v-col>
            <v-col class="d-flex" cols="8" sm="4">
              <v-select
                :items="tiposerv"
                label="Tipo Servicio"
                outlined
                clearable
                return-object
                hide-details
                v-model="form.tiposerv"
                required
              ></v-select>
            </v-col>
            <v-col class="d-flex" cols="3" sm="3">
              <v-text-field
                label="Cod.Rips"
                clearable
                outlined
                required
                v-model="form.cod_rips"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex" cols="8">
              <v-select
                :items="agrpserv"
                label="Grupo de Servicio"
                outlined
                clearable
                return-object
                hide-details
                v-model="form.agrpserv"
                required
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex" cols="8">
              <v-select
                :items="servicios"
                label="Servicio"
                outlined
                clearable
                return-object
                hide-details
                v-model="form.servicio"
                required
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex" cols="8" sm="4">
              <v-select
                :items="categorias"
                label="Categoria"
                outlined
                clearable
                return-object
                hide-details
                :item-text="format_categorias"
                v-model="form.categorias"
                required
              ></v-select>
            </v-col>
            <v-col class="d-flex" cols="8" sm="4">
              <v-select
                :items="subcategorias"
                label="Sub_Categoria"
                outlined
                clearable
                return-object
                hide-details
                :item-text="format_subcategorias"
                v-model="form.subcategorias"
                required
              ></v-select>
            </v-col>
            <v-col class="d-flex" cols="8" sm="4">
              <v-select
                :items="clasif256"
                label="Clasificacion Res.256"
                outlined
                clearable
                return-object
                hide-details
                v-model="form.clasif256"
                required
              ></v-select>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col class="d-flex" cols="12" sm="4">
              <v-switch v-model="form.estado" label="Bloquear"></v-switch>
            </v-col>

            <v-col class="d-flex" cols="12" sm="4">
              <v-switch v-model="form.eliminar" label="Eliminar"></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-2"
            color="red"
            text
            @click="
              dialogo.estado = false;
              init_form();
            "
            >Cancelar</v-btn
          >
          <v-btn
            class="ma-2 px-4"
            color="success"
            depressed
            large
            @click="guardar()"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import post from "../../methods.js";
import { FlowerSpinner } from "epic-spinners";

export default {
  components: {
    FlowerSpinner,
  },
  data() {
    return {
      loader: false,
      dialogo: {
        estado: false,
        titulo: null,
        tipo: null,
      },
      dialog: true,
      valid: false,
      dialogPicker: false,
      dialogPickerfin: false,
      singleExpand: true,
      expanded: [],
      contenido: [],
      categorias: [],
      subcategorias: [],
      cuentas: [],

      clasif256: [
        { text: "Primera Vez Medicina General", value: 1 },
        { text: "Primera Vez Odontologia General", value: 2 },
        { text: "Primera Vez Medicina Interna", value: 3 },
        { text: "Primera Vez Pediatria", value: 4 },
        { text: "Primera Vez Ginecologia", value: 5 },
        { text: "Primera Vez Obstetricia", value: 6 },
        { text: "Primera Vez Cirugia General", value: 7 },
        { text: "Primera Vez Ecografias", value: 8 },
        { text: "Primera Vez Resonancia Magnetica", value: 9 },
      ],

      clasifserv: [
        { text: "Consultas-AC-", value: 1 },
        { text: "Medicamentos-AM-", value: 2 },
        { text: "Procedimientos-AP-", value: 3 },

        { text: "Otros Servicios-AT", value: 99 },
      ],
      tiposerv: [
        { text: "Materiales e Insumos", value: 1 },
        { text: "Traslados", value: 2 },
        { text: "Estancias", value: 3 },
        { text: "Honorarios", value: 4 },
        { text: "No aplica", value: 0 },
      ],

      agrpserv_3374: [
        { text: "Consultas", value: 1 },
        { text: "Procedimientos de Diagnosticos", value: 2 },
        { text: "Procedimientos Terapeuticos No Quirurgicos", value: 3 },
        { text: "Procedimientos Terapeuticos Quirurgicos", value: 4 },
        { text: "Procedimientos de PyP", value: 5 },
        { text: "Estancias", value: 6 },
        { text: "Honorarios", value: 7 },
        { text: "Derechos de Sala", value: 8 },
        { text: "Materiales e Insumos", value: 9 },
        { text: "Banco de Sangre", value: 10 },
        { text: "Prótesis y órtesis", value: 11 },
        { text: "Medicamentos Pos", value: 12 },
        { text: "Medicamentos No Pos", value: 13 },
        { text: "Traslado de pacientes", value: 14 },
      ],

      agrpserv: [
        { text: "Consulta externa", value: 21 },
        { text: "Apoyo diagnóstico y complementación terapéutica", value: 22 },
        { text: "Internación", value: 23 },
        { text: "Quirúrgico", value: 24 },
        { text: "Atención inmediata", value: 25 },
      ],

      servicios: [
        { text: "URGENCIAS", value: 1102 },
        { text: "OTRAS CONSULTAS GENERALES", value: 371 },

        { text: "CUIDADO INTERMEDIO NEONATAL", value: 105 },
        { text: "CUIDADO INTERMEDIO PEDIATRICO", value: 106 },
        { text: "CUIDADO INTERMEDIO ADULTOS", value: 107 },
        { text: "CUIDADO INTENSIVO NEONATAL", value: 108 },
        { text: "CUIDADO INTENSIVO PEDIATRICO", value: 109 },
        { text: "CUIDADO INTENSIVO ADULTOS", value: 110 },
        { text: "ATENCION DEL PARTO", value: 1101 },
        { text: "URGENCIAS", value: 1102 },
        { text: "TRANSPORTE ASISTENCIAL BASICO", value: 1103 },
        { text: "TRANSPORTE ASISTENCIAL MEDICALIZADO", value: 1104 },
        { text: "ATENCION PREHOSPITALARIA", value: 1105 },
        { text: "CUIDADO BASICO NEONATAL", value: 120 },
        { text: "HOSPITALIZACION ADULTOS", value: 129 },
        { text: "HOSPITALIZACION PEDIATRICA", value: 130 },
        { text: "HOSPITALIZACION EN SALUD MENTAL", value: 131 },
        { text: "HOSPITALIZACION PARCIAL", value: 132 },
        { text: "HOSPITALIZACION PACIENTE CRONICO CON VENTILADOR", value: 133 },
        { text: "HOSPITALIZACION PACIENTE CRONICO SIN VENTILADOR", value: 134 },
        {
          text: "HOSPITALIZACION EN CONSUMO DE SUSTANCIAS PSICOACTIVAS",
          value: 135,
        },
        {
          text: "CUIDADO BASICO DEL CONSUMO DE SUSTANCIAS PSICOACTIVAS",
          value: 138,
        },
        { text: "CIRUGIA DE CABEZA Y CUELLO", value: 201 },
        { text: "CIRUGIA CARDIOVASCULAR", value: 202 },
        { text: "CIRUGIA GENERAL", value: 203 },
        { text: "CIRUGIA GINECOLOGICA", value: 204 },
        { text: "CIRUGIA MAXILOFACIAL", value: 205 },
        { text: "CIRUGIA ORTOPEDICA", value: 207 },
        { text: "CIRUGIA OFTALMOLOGICA", value: 208 },
        { text: "CIRUGIA OTORRINOLARINGOLOGIA", value: 209 },
        { text: "CIRUGIA ONCOLOGICA", value: 210 },
        { text: "CIRUGIA ORAL", value: 211 },
        { text: "CIRUGIA PEDIATRICA", value: 212 },
        { text: "CIRUGIA PLASTICA Y ESTETICA", value: 213 },
        { text: "CIRUGIA VASCULAR Y ANGIOLOGICA", value: 214 },
        { text: "CIRUGIA UROLOGICA", value: 215 },
        { text: "OTRAS CIRUGIAS", value: 217 },
        { text: "CIRUGIA ENDOVASCULAR NEUROLOGICA", value: 218 },
        { text: "CIRUGIA ONCOLOGICA PEDIATRICA", value: 227 },
        { text: "CIRUGIA DE LA MANO", value: 231 },
        { text: "CIRUGIA DE MAMA Y TUMORES TEJIDOS BLANDOS", value: 232 },
        { text: "CIRUGIA DERMATOLOGICA", value: 233 },
        { text: "CIRUGIA DE TORAX", value: 234 },
        { text: "CIRUGIA GASTROINTESTINAL", value: 235 },
        { text: "CIRUGIA PLASTICA ONCOLOGICA", value: 237 },
        { text: "NEUROCIRUGIA", value: 245 },
        { text: "ANESTESIA", value: 301 },
        { text: "CARDIOLOGIA", value: 302 },
        { text: "CIRUGIA CARDIOVASCULAR", value: 303 },
        { text: "CIRUGIA GENERAL", value: 304 },
        { text: "CIRUGIA PEDIATRICA", value: 306 },
        { text: "DERMATOLOGIA", value: 308 },
        { text: "DOLOR Y CUIDADOS PALIATIVOS", value: 309 },
        { text: "ENDOCRINOLOGIA", value: 310 },
        { text: "ENDODONCIA", value: 311 },
        { text: "ENFERMERIA", value: 312 },
        { text: "ESTOMATOLOGIA", value: 313 },
        { text: "GASTROENTEROLOGIA", value: 316 },
        { text: "GENETICA", value: 317 },
        { text: "GERIATRIA", value: 318 },
        { text: "GINECOBSTETRICIA", value: 320 },
        { text: "HEMATOLOGIA", value: 321 },
        { text: "INFECTOLOGIA", value: 323 },
        { text: "INMUNOLOGIA", value: 324 },
        { text: "MEDICINA FAMILIAR", value: 325 },
        { text: "MEDICINA FISICA Y DEL DEPORTE", value: 326 },
        { text: "MEDICINA FISICA Y REHABILITACION", value: 327 },
        { text: "MEDICINA GENERAL", value: 328 },
        { text: "MEDICINA INTERNA", value: 329 },
        { text: "NEFROLOGIA", value: 330 },
        { text: "NEUMOLOGIA", value: 331 },
        { text: "NEUROLOGIA", value: 332 },
        { text: "NUTRICION Y DIETETICA", value: 333 },
        { text: "ODONTOLOGIA GENERAL", value: 334 },
        { text: "OFTALMOLOGIA", value: 335 },
        { text: "ONCOLOGIA CLINICA", value: 336 },
        { text: "OPTOMETRIA", value: 337 },
        { text: "ORTODONCIA", value: 338 },
        { text: "ORTOPEDIA Y/O TRAUMATOLOGIA", value: 339 },
        { text: "OTORRINOLARINGOLOGIA", value: 340 },
        { text: "PEDIATRIA", value: 342 },
        { text: "PERIODONCIA", value: 343 },
        { text: "PSICOLOGIA", value: 344 },
        { text: "PSIQUIATRIA", value: 345 },
        { text: "REHABILITACION ONCOLOGICA", value: 346 },
        { text: "REHABILITACION ORAL", value: 347 },
        { text: "REUMATOLOGIA", value: 348 },
        { text: "TOXICOLOGIA", value: 354 },
        { text: "UROLOGIA", value: 355 },
      ],

      search: "",
      form: {},
      headers: [
        {
          text: "Codigo",
          align: "center",
          value: "identificacion_cups",
          class: "section-header",
        },
        {
          text: "Descripción",
          align: "left",
          value: "descripcion_cups",
          class: "section-header",
        },
        {
          text: "Clasificación",
          align: "center",
          value: "descclasif_cups",
          class: "section-header",
        },
        {
          text: "Tipo Serv",
          align: "center",
          value: "tiposer_cups",
          class: "section-header",
        },
        {
          text: "Agrp. Serv",
          align: "center",
          value: "agrpsevr_cups",
          class: "section-header",
        },
        {
          text: "Vlr Soat",
          align: "right",
          value: "vlrsoat_cups",
          class: "section-header",
        },
        {
          text: "Vlr Iss2001",
          align: "right",
          value: "vlriss_cups",
          class: "section-header",
        },
        {
          text: "Cod Rips",
          align: "right",
          value: "idrips_cups",
          class: "section-header",
        },

        {
          text: "Categoría",
          align: "center",
          value: "descripcat_cups",
          class: "section-header",
        },
        {
          text: "Cuenta",
          align: "right",
          value: "cuenta_cups",
          class: "section-header",
        },
        {
          text: "Estado",
          align: "center",
          value: "estado_cups",
          class: "section-header",
        },
        {
          text: "Opciones",
          value: "edit",
          align: "center",
          class: "section-header",
        },
      ],
      errores: {
        codigo: false,
        estado: false,
      },
      card_estado: false,
    };
  },
  created() {
    this.cargarcontenido();
    this.cargarcuentas();
    this.cargarcategorias();
    this.cargarsubcategorias();
  },
  computed: {},
  methods: {
    editar_item(data) {
      var item = JSON.parse(JSON.stringify(data));
      this.dialogo.estado = true;
      this.dialogo.titulo = "Modificar Registro";
      this.dialogo.tipo = 1;
      this.form.codigo = item.identificacion_cups;
      this.form.descripcion = item.descripcion_cups;
      this.form.codsoat = item.idsoat_cups.trim();
      this.form.vsoat = item.vlrsoat_cups.trim();
      this.form.cod_rips = item.idrips_cups.trim();
      this.form.codiss = item.codiss;
      this.form.viss = item.viss;
      this.form.edad = item.edad;
      this.form.genero = item.genero;
      this.form.ctavta = item.cuenta_cups;

      console.log(item);
      var busqueda_ctavtas = this.cuentas.find(
        (el) => parseInt(el.cod_puc) == parseInt(item.cuenta_cups)
      );
      this.form.ctavta = busqueda_ctavtas;

      var busqueda_tiposerv = this.tiposerv.find(
        (el) => parseInt(el.value) == parseInt(item.tiposer_cups)
      );
      this.form.tiposerv = busqueda_tiposerv;

      var busqueda_clasifserv = this.clasifserv.find(
        (el) => parseInt(el.value) == parseInt(item.clasifsevr_cups)
      );
      this.form.clasifserv = busqueda_clasifserv;

      var busqueda_agrpserv = this.agrpserv.find(
        (el) => parseInt(el.value) == parseInt(item.agrpsevr_cups)
      );
      this.form.agrpserv = busqueda_agrpserv;

      var busqueda_servicio = this.servicios.find(
        (el) => parseInt(el.value) == parseInt(item.codserv_cups)
      );
      this.form.servicio = busqueda_servicio;

      var busqueda_categoria = this.categorias.find(
        (el) => parseInt(el.codigo_rep) == parseInt(item.categoria_cups)
      );
      this.form.categorias = busqueda_categoria;

      var busqueda_subcategoria = this.subcategorias.find(
        (el) => parseInt(el.codigo_rep) == parseInt(item.subcategoria_cups)
      );
      this.form.subcategorias = busqueda_subcategoria;

      var busqueda_res256 = this.clasif256.find(
        (el) => parseInt(el.value) == parseInt(item.tipores256_cups)
      );
      this.form.clasif256 = busqueda_res256;

      this.form.estado = item.estado_cups == "2" ? true : false;
    },
    guardar: function () {
      var data = JSON.parse(JSON.stringify(this.form));
      if (!data.codigo) {
        this.errores.codigo = true;
        this.send_error("Campo Obligatorio!");
      } else {
        this.format_envio(data);
      }
    },

    format_envio(data) {
      this.card_estado = true;
      var codigo = data.codigo;
      var descripcion = data.descripcion;
      var codsoat = data.codsoat ? data.codsoat : "0";
      var vlrsoat = data.vsoat ? data.vsoat : "0";
      var codiss = data.codiss ? data.codiss : "0";
      var vlriss = data.viss ? data.viss : "0";
      var edad = data.edad ? data.edad : "0";
      var genero = data.genero;
      var ctavta = data.ctavta ? data.ctavta.cod_puc : "";
      let cod_rips = data.cod_rips ? data.cod_rips.trim() : "";
      var tiposerv = data.tiposerv ? data.tiposerv.value : "0";
      var clasifserv = data.clasifserv ? data.clasifserv.value : "0";
      var agrpserv = data.agrpserv ? data.agrpserv.value : "0";
      var codservicio = data.servicio ? data.servicio.value : "0";
      var categoria = data.categorias ? data.categorias.codigo_rep : "0";
      var subcategoria = data.subcategorias
        ? data.subcategorias.codigo_rep
        : "0";

      var estado = data.estado ? "1" : "0";
      var eliminar = data.eliminar ? "1" : "0";
      let clasif256 = data.clasif256 ? data.clasif256.value : "0";

      let datos = {
        url: "Clinico/dlls/ClCfServProc.DLL",
        data:
          sessionStorage.Sesion +
          "|" +
          codigo +
          "|" +
          descripcion +
          "|" +
          codsoat +
          "|" +
          vlrsoat +
          "|" +
          codiss +
          "|" +
          vlriss +
          "|" +
          genero +
          "|" +
          edad +
          "|" +
          ctavta +
          "|" +
          estado +
          "|" +
          eliminar +
          "|" +
          tiposerv +
          "|" +
          clasifserv +
          "|" +
          agrpserv +
          "|" +
          categoria +
          "|" +
          subcategoria +
          "|" +
          clasif256 +
          "|" +
          codservicio +
          "|" +
          cod_rips +
          "|",
        method: "",
      };
      post
        .postData(datos)
        .then((data) => {
          this.$emit("snack", {
            color: "success",
            text: "Registro guardado correctamente",
            estado: true,
          });

          this.card_estado = false;
          this.dialogo.estado = false;
          this.init_form();
          this.cargarcontenido();
        })
        .catch((error) => {
          this.card_estado = false;
          this.send_error("Error al grabar Registro");
        });
    },
    agregar_item() {
      this.init_form();
      this.form.estado = 0;
      this.form.activacion = this.$moment().format("YYYY-MM-DD");
      this.dialogo.titulo = "Agregar nuevo Registro";
      this.dialogo.estado = true;
      this.dialogo.tipo = 0;
    },
    cargarcategorias() {
      this.loader = true;
      post
        .postData({
          url: "Clinico/dlls/CfCategoriaJ.dll",
          data: sessionStorage.Sesion + "|" + "1" + "|",
          method: "",
        })
        .then((data) => {
          data.pop();
          this.loader = false;
          this.categorias = JSON.parse(JSON.stringify(data));
        })
        .catch((err) => {
          this.loader = false;
          this.$emit("snack", {
            color: "error",
            text: "Error en Categorias",
            estado: true,
          });
        });
    },
    cargarsubcategorias() {
      this.loader = true;
      post
        .postData({
          url: "Clinico/dlls/CfCategoriaJ.dll",
          data: sessionStorage.Sesion + "|" + "2" + "|",
          method: "",
        })
        .then((data) => {
          data.pop();
          this.loader = false;
          this.subcategorias = JSON.parse(JSON.stringify(data));
        })
        .catch((err) => {
          this.loader = false;
          this.$emit("snack", {
            color: "error",
            text: "Error en SubCategorias",
            estado: true,
          });
        });
    },
    init_form() {
      this.form = {
        codigo: null,
        eliminar: false,
      };

      this.errores = {
        codigo: false,
      };
    },

    descripcionEstado(e) {
      return e == "1" ? "Desactivado" : "Activo";
    },
    imprimir_excel() {
      let data = this.contenido;
      let data_parse = [];

      data_parse = [...data];

      let columnas = [
        {
          title: "Codigo",
          value: "identificacion_cups",
          format: "string",
        },
        {
          title: "Descripción",
          value: "descripcion_cups",
          format: "string",
        },
        {
          title: "Clasificación Rips",
          value: "descclasif_cups",
        },
        {
          title: "Tipo Serv.",
          value: "tiposer_cups",
        },
        {
          title: "Agrp_Servicio",
          value: "agrpsevr_cups",
          format: "string",
        },
        {
          title: "Cod_Soat",
          value: "idsoat_cups",
          format: "string",
        },
        {
          title: "Vlr_Soat",
          value: "vlrsoat_cups",
        },
        {
          title: "Cod_Iss",
          value: "idiss_cups",
          format: "string",
        },
        {
          title: "Vrl_Iss_2001",
          value: "vlriss_cups",
        },
        {
          title: "Categoria",
          value: "categoria_cups",
        },
        {
          title: "Cta_Contable",
          value: "cuenta_cups",
        },
        {
          title: "Genero",
          value: "genero_cups",
        },
        {
          title: "Edad",
          value: "edad_cups",
        },
        {
          title: "Id_Rips",
          value: "idrips_cups",
          format: "string",
        },
        {
          title: "Grupo",
          value: "grupo_cups",
        },
        {
          title: "Estado",
          value: "estado_cups",
        },
      ];

      let header_format = [
        { text: "SERVICIOS Y PROCEDIMIENTOS", bold: true, size: 16 },
        "",
        "",
        "",
      ];

      let logo_src = require(`../../assets/image/clientes/${parseFloat(
        sessionStorage.Sesion.substr(0, 15)
      )}.png`);
      this.pdfs.getBase64(logo_src).then((logo) => {
        this.excel
          ._informe({
            sheetName: "Informe Servicios y Procedimientos",
            header: header_format,
            logo,
            tabla: {
              columnas,
              totalsRow: false,
              data: data_parse,
              // heightRow: 35,
              theme: "TableStyleMedium2",
            },
            archivo: `INFORME SERVICIOS Y PROCEDIMIENTOS-${new Date().getTime()}`,
          })
          .then((data) => {
            console.log("Impresion terminada");
          });
      });
    },

    cargarcontenido() {
      this.loader = true;
      post
        .postData({
          url: "Clinico/dlls/ClCfServProcJ.dll",
          data: sessionStorage.Sesion + "|",
          method: "",
        })
        .then((data) => {
          this.loader = false;
          this.contenido = JSON.parse(JSON.stringify(data));
        })
        .catch((err) => {
          this.loader = false;
          this.$emit("snack", {
            color: "error",
            text: "Error al cargar Cups",
            estado: true,
          });
        });
    },
    cargarcuentas: function () {
      post
        .postData({
          url: "Financiero/dlls/CfCuentasJ.DLL",
          data: sessionStorage.Sesion + "|" + "4" + "|",
          method: "",
        })
        .then((data) => {
          this.cuentas = data;
        })
        .catch((err) => {
          this.$emit("snack", {
            color: "error",
            text: "Error al cargar cuentas",
            estado: true,
          });
        });
    },
    format_categorias(val) {
      return `${val.descripcion_rep}`;
    },

    format_subcategorias(val) {
      return `${val.descripcion_rep}`;
    },
    format_cuentas(val) {
      return `${val.cod_puc} - ${val.descrip_puc}`;
    },

    send_error(msj) {
      console.error("Error", msj);
      this.$emit("snack", {
        color: "error",
        text: msj,
        estado: true,
      });
    },
  },
};
</script>